<template>
    <view-method-component :currentMethod="currentMethod" @back="handleBack" @editMethod="handleEditMethod" @downloadMethodFile="handleDownloadMethodFile"><h1>GRAce</h1></view-method-component>
</template>

<script>
import ViewMethodComponent from '@/components/method/ViewMethodComponent'
import axios from "axios";
import { mapGetters, mapMutations } from 'vuex'

export default {
    name: 'ViewMethod',
    components: {ViewMethodComponent},
    data: function () {
        return {
            component_url: 'experiments/methods/',
            currentMethod: {}
        }
    },

    computed: {
        ...mapGetters ([
            'base_url', 'currentMethodID', 'auth_header'
        ])
    },

    methods: {
        ...mapMutations([
            'SET_BREADCRUMB', 'CHANGE_METHOD_ID'
        ]),
        setBreadcrumb: function(){
            this.SET_BREADCRUMB(this.$route.meta.breadcrumb)
        },
        //set global MethodId
        setMethodId: function(){
            this.CHANGE_METHOD_ID(this.currentMethod.id)
        },
        getMethod: function(){ 
            axios
                .get(
                    this.base_url+this.component_url +
                    this.currentMethod.id,
                    {
                        headers: this.auth_header
                    }
                )
                .then(response => {
                    this.currentMethod = response.data;
                })
                .catch(error => {
                    console.log("Something went wrong getting the current method");
                });
        },
        handleEditMethod: function(currentMethod) {
            console.log("handleEditMethod: currMeth is ", currentMethod.name)
            this.$router.push({ name: "EditMethod", params: { id: currentMethod.id } });
        },
        handleBack: function() {
            console.log("handleBack function...")
            this.$router.push({ name: "Methods", params: {} });
        },
        handleDownloadMethodFile: function(methodFile){
            var blob;
            blob = this.convertBase64toBlob(methodFile, 'application/pdf');
            var blobURL = URL.createObjectURL(blob);
            console.log("from handleDownloadMethodFile")
            window.open(blobURL);
        },
        convertBase64toBlob: function(str){
            var pos = str.indexOf(';base64,');
            var type = 'application/pdf';
            var b64 = str;

            // decode base64
            var imageContent = atob(b64);

            // create an ArrayBuffer and a view (as unsigned 8-bit)
            var buffer = new ArrayBuffer(imageContent.length);
            var view = new Uint8Array(buffer);

            // fill the view, using the decoded base64
            for(var n = 0; n < imageContent.length; n++) {
                view[n] = imageContent.charCodeAt(n);
            }

            // convert ArrayBuffer to Blob
            var blob = new Blob([buffer], { type: type });

            return blob;
        }
    },

    mounted: function() {
        this.setBreadcrumb();
        if (this.$route.params.id) {
            this.currentMethod.id = this.$route.params.id;   
            //set method id in vuex
            this.setMethodId()
            this.getMethod();         
        }
        else {
            console.log("OpenMethod view no router params.id")
            this.currentMethod.id = this.currentMethodID
            this.setMethodId()
            this.getMethod();
        }        
    }
}
</script>

